// Validate data for calculating scheduled payments and log any error that occurs
// return true if error is severe and paymentscheduling should be blocked to avoid further issues
// return false if error should not block the scheduling of the payments (that still means the error will be logged into Sentry and fixed)
const validateScheduledPaymentsData = (logger, params) => {
  let hasBlockingError = false

  const { remainingAmount, prepaymenyAmountPercentage, prepaymentAmountDueDate, amountWillBePaidDaysBefore } = params

  if (remainingAmount < 0) {
    // (total - prepayment amount) resulted in negative remaining amount
    // block the automatic payments if the difference is bigger than 1 cent
    hasBlockingError = remainingAmount < -0.01

    logger.logError('prepayment is bigger than total amount', remainingAmount < -0.01)
  }

  if (prepaymenyAmountPercentage < 0 || prepaymenyAmountPercentage > 100) {
    // prepaymenyAmountPercentage is not a valid percentage value
    hasBlockingError = true

    logger.logError('prepaymenyAmountPercentage is invalid', true)
  }

  if (prepaymentAmountDueDate < 0 || amountWillBePaidDaysBefore < 0) {
    // prepaymentAmountDueDate and amountWillBePaidDaysBefore must be positive integers and
    // prepaymentAmountDueDate must be greater or equal to amountWillBePaidDaysBefore because it is the first payment
    logger.logError('prepaymentAmountDueDate or amountWillBePaidDaysBefore numbers are not valid', false)
  }

  return hasBlockingError
}

export default validateScheduledPaymentsData
